import React from "react";
import "./Header.css";

function Header() {
  return (
    <div className="header">
      <img className="headerImg" src="https://picsum.photos/1920/1080" alt="" />
      <div className="headerTitles">
        <span className="headerTitleLg">ZeBlogs</span>
        <span className="headerTitleSm">
          Write your own fantasies into existence!
        </span>
      </div>
    </div>
  );
}

export default Header;
